import styled from "@emotion/styled";
import { UiTheme } from "@nykaa/payment-ui/src/@types";
import { getHexToRgba } from "@nykaa/payment-ui/src/common/helpers/getHexToRgba";


export const PaymentOptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }: UiTheme) => theme.colors.white};
  ${({ theme }: UiTheme) => theme.borders.border100};
  border-color: ${({ theme }: UiTheme) => getHexToRgba(theme.colors.chipColor, 0.16)};
  border-radius: ${({ theme }: UiTheme) => theme.borders.radiusPrimary};
`;

export const BottomSheetContentLayout = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 8px;
`;

export const CustomTextLayout = styled.div`
  padding-bottom: 4px;
`;

export const CustomIconLayout = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-bottom: 8px;
  min-height: 56px;
`;

export const CustomButtonLayout = styled.div`
  padding: 16px 0px;
`;

export const PaymentMethodWrapper = styled.div`
  border-bottom: 1px solid ${({ theme }: UiTheme) => getHexToRgba(theme?.colors?.chipColor, 0.16)};
`;

export const WalletTileLayout = styled.div`
  display: flex;
  position: relative;
  margin: 16px 0;
  min-height: 56px;
  flex-direction: row;
  align-items: center;
  background-color: ${({ theme }: UiTheme) => theme.colors.white};
  ${({ theme }: UiTheme) => theme.borders.border100};
  border-color: ${({ theme }: UiTheme) => getHexToRgba(theme.colors.chipColor, 0.08)};
  border-radius: ${({ theme }: UiTheme) => theme.borders.radiusPrimary};
`;

export const ToggleWrapper = styled.div`
  padding-inline: 5px 16px;
`;
